function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 20,
  y: 5,
  width: 60,
  height: 90,
  fill: "transparent",
  stroke: "black"
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 40,
  y: 45,
  width: 4,
  height: 30
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  x: 56,
  y: 45,
  width: 4,
  height: 30
});

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  x: 50,
  y: 35,
  width: 1,
  height: 60
});

var _ref6 = /*#__PURE__*/React.createElement("rect", {
  x: 20,
  y: 35,
  width: 60,
  height: 1
});

var _ref7 = /*#__PURE__*/React.createElement("rect", {
  x: 37.5,
  y: 15,
  width: 25,
  height: 3
});

var _ref8 = /*#__PURE__*/React.createElement("rect", {
  x: 5,
  y: 70,
  width: 35,
  height: 1
});

var _ref9 = /*#__PURE__*/React.createElement("rect", {
  x: 5,
  y: 95,
  width: 15,
  height: 1
});

var _ref10 = /*#__PURE__*/React.createElement("rect", {
  x: 12,
  y: 70,
  width: 1,
  height: 25
});

function SvgFromGround(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFromGround);
export default __webpack_public_path__ + "static/media/fromGround.5a983078.svg";
export { ForwardRef as ReactComponent };